module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": _vm.type === 'catalog' ? '14' : '13',
      "height": _vm.type === 'catalog' ? '14' : '14',
      "viewBox": _vm.type === 'catalog' ? '0 0 14 14' : '0 0 13 18'
    }
  }, [(_vm.type === 'catalog') ? _c('path', {
    attrs: {
      "fill": _vm.color.catalog,
      "fill-rule": "evenodd",
      "d": "M11 14a3 3 0 1 1 3-3 3 3 0 0 1-3 3zm0-8a3 3 0 1 1 3-3 3 3 0 0 1-3 3zm-8 8a3 3 0 1 1 3-3 3 3 0 0 1-3 3zm0-8a3 3 0 1 1 3-3 3 3 0 0 1-3 3z"
    }
  }) : (_vm.type === 'map') ? _c('path', {
    attrs: {
      "fill": _vm.color.map,
      "fill-rule": "evenodd",
      "d": "M6.5 18C5.42 18.006 0 9.572 0 6.75a6.5 6.5 0 1 1 13 0C13 9.534 7.56 18.006 6.5 18zm0-8.437A2.815 2.815 0 1 1 9.21 6.75 2.76 2.76 0 0 1 6.5 9.563z"
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1315e921","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/nav/switcher/components/Icon.vue
// module id = bd24480a1a152a410e1f
// module chunks = 0